/* eslint-disable max-len */
import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const SearchIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1694_347)">
      <path
        d="M19.361 18.0382L14.601 13.1952C15.8249 11.7719 16.4954 9.98113 16.4954 8.11686C16.4954 3.76117 12.8729 0.217407 8.42045 0.217407C3.96797 0.217407 0.345459 3.76117 0.345459 8.11686C0.345459 12.4725 3.96797 16.0163 8.42045 16.0163C10.092 16.0163 11.6849 15.5231 13.0467 14.5868L17.8429 19.4666C18.0434 19.6703 18.313 19.7826 18.602 19.7826C18.8755 19.7826 19.1349 19.6806 19.3319 19.4952C19.7504 19.1012 19.7637 18.448 19.361 18.0382ZM8.42045 2.27813C11.7115 2.27813 14.3889 4.89732 14.3889 8.11686C14.3889 11.3364 11.7115 13.9556 8.42045 13.9556C5.12937 13.9556 2.45198 11.3364 2.45198 8.11686C2.45198 4.89732 5.12937 2.27813 8.42045 2.27813Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1694_347">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
